import { QueryClient } from '@tanstack/vue-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // most lists don't need fresher than 1 min
      staleTime: 60_000,
      // keep cached pages around for back-nav within a session
      gcTime: 5 * 60_000,
      // default of 3 x 120 s timeout = 6 min worst-case hang on flaky network
      retry: 1,
      // webview fires focus on every keyboard open/close
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      // mutations are non-idempotent (payments, bookings, analytics events).
      // without server-side idempotency keys, an auto-retry after a lost
      // response could double-charge or double-book — let the user re-tap.
      retry: 0,
    },
  },
});
